var __jsx = React.createElement;
import React from "react";
import MuscleModal from "../modal";
import { MuscleButton } from "../buttons";
import { useTranslations } from "next-intl";
import { cn } from "@lib/cn";
import APP_CONFIGURATION from "@lib/app.config";
import { useMediaQuery } from "react-responsive";
import useViewportDimensions from "@lib/hooks/use-viewport-dimensions";
import { BREAKPOINTS } from "@lib/constants";
import TextWithLinks from "../text-with-links";
const MuscleMessageModal = _ref => {
  var _props$animation;
  let {
    isOpen,
    setIsOpen,
    props
  } = _ref;
  const t = useTranslations();
  const {
    modal_description_class,
    modal_title_class,
    modal_actions_class
  } = APP_CONFIGURATION.colors.globals.modal;
  const isMobile = useMediaQuery({
    query: "(max-width: ".concat(BREAKPOINTS.md, "px)")
  });
  const {
    height,
    width
  } = useViewportDimensions(0.8, isMobile ? 0.8 : 0.8);
  const renderActions = () => {
    var _props$actions;
    return (_props$actions = props.actions) === null || _props$actions === void 0 ? void 0 : _props$actions.map((action, index) => __jsx("div", {
      key: "message-button-container-".concat(index)
    }, __jsx(MuscleButton, {
      key: "message-button-".concat(index),
      variant: action.buttonVariant || "solidMd",
      onClick: () => {
        action.onClick();
        setIsOpen(false);
      }
    }, action.text)));
  };
  return __jsx(MuscleModal, {
    openState: isOpen,
    setOpenState: setIsOpen,
    onClose: props.onClose,
    closeable: props.closeable,
    title: props.title
  }, __jsx("div", {
    className: cn("flex flex-col gap-8  items-center"),
    style: {
      width: isMobile ? width : '384px'
    }
  }, props.logo ? __jsx("img", {
    src: props.logo,
    alt: props.title,
    className: cn("w-full max-w-[200px] ", props.imageClassname)
  }) : null, (_props$animation = props.animation) !== null && _props$animation !== void 0 ? _props$animation : __jsx(React.Fragment, null, props.animation), props.image ? __jsx("img", {
    src: props.image,
    alt: props.title,
    className: "w-full max-h-[170px] max-w-[200px]"
  }) : null, props.message && !props.richMessage ? __jsx("p", {
    className: cn("whitespace-pre-wrap tx-pmd-regular text-black text-left md:text-center", modal_description_class)
  }, props.message) : null, props.richMessage ? __jsx(TextWithLinks, {
    text: props.richMessage.text,
    textStyle: cn("whitespace-pre-wrap tx-pmd-regular text-black text-left md:text-center", props.richMessage.textStyle),
    linksStyle: props.richMessage.linksStyle,
    boldStyle: props.richMessage.boldStyle,
    linksActions: props.richMessage.links.map(link => {
      if (link && window) {
        return () => {
          window.open(link, '__blank');
        };
      }
      return () => {};
    })
  }) : null, __jsx("div", {
    className: cn("flex flex-col md:flex-row  justify-center w-full sm:items-center h-full", modal_actions_class)
  }, renderActions(), props.addCancelButton ? __jsx(MuscleButton, {
    variant: "outlineMd",
    onClick: () => setIsOpen(false)
  }, t("Shared.CANCEL")) : null)));
};
export default MuscleMessageModal;